import { CreateActionsType } from './type';
import AudioImage from '../public/assets/Audio.svg';
import Microphone from '../public/assets/Microphone.svg';
import LandscapeButton from '../public/assets/LandscapeButton.svg';
import PotraitButton from '../public/assets/PotraitButton.svg';
import SquareButton from '../public/assets/SquareButton.svg';
import { AspectRatios, CaptionStyleId, Stroke, TextShadow } from '@t2c/ai-video-editor';
import { AiImageModelDetails, AiVideoModelDetails, DashboardCardDataType, Status } from '../@types';
import { CSSProperties } from 'react';

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export enum MediaTypeEnum {
  AUDIO = 'audio',
  VIDEO = 'video',
  AVATAR = 'avatar',
}
export enum UploadStepsEnum {
  SelectFile = 'SelectFile',
  FileUploading = 'FileUploading',
  FileUploaded = 'FileUploaded',
  InProgress = 'IsInProgress',
}

export enum VideoRatioEnum {
  square = 'square',
  landscape = 'landscape',
  potrait = 'potrait',
}

export const FileTypes = {
  avatar: ['jpg', 'jpeg', 'png', 'mp4', 'mov', 'avi', 'mkv'],
  video: ['mp4'],
  audio: ['ogg', 'wav', 'mp3', 'aac'],
};

export enum CreateActionsListIds {
  Broll = 'broll',
  AvatarVideo = 'avatarVideo',
  Avatar = 'avatar',
  AudioCloning = 'audioCloning',
  TextToAudio = 'textToAudio',
}
export const CreateActionsList: CreateActionsType[] = [
  {
    id: CreateActionsListIds.Broll,
    buttonTitle: 'Captions & Effects',
    header: 'Create Captions & Effects Video',
    subheader: '',
    type: MediaTypeEnum.VIDEO,
    fileSupported: FileTypes.video,
    icon: 'broll-caption.svg',
  },
  {
    id: CreateActionsListIds.AvatarVideo,
    buttonTitle: 'Create Video',
    header: 'Create Video',
    subheader: 'Select an avatar and paste or type your script to get the video generated.',
    type: MediaTypeEnum.VIDEO,
    fileSupported: FileTypes.video,
    icon: 'create-video.svg',
  },
  {
    id: CreateActionsListIds.Avatar,
    buttonTitle: 'Create Avatar',
    header: 'Create Avatar',
    subheader:
      'Upload an audio file to clone your voice and make any avatar speak your words with text.',
    // background: '/assets/createAvatar.png',
    type: MediaTypeEnum.AVATAR,
    fileSupported: FileTypes.avatar,
    icon: 'created-avatar.svg',
  },
  {
    id: CreateActionsListIds.AudioCloning,
    buttonTitle: 'Audio Cloning',
    header: 'Clone Audio',
    subheader:
      'Upload an audio file to clone your voice and make any avatar speak your words with text.',
    type: MediaTypeEnum.AUDIO,
    fileSupported: FileTypes.audio,
    icon: 'cloned-audio.svg',
  },
  {
    id: CreateActionsListIds.TextToAudio,
    buttonTitle: 'Audio-Voiceover',
    header: 'Audio-Voiceover',
    subheader:
      'Upload an audio file to clone your voice and make any avatar speak your words with text.',
    type: MediaTypeEnum.AUDIO,
    fileSupported: FileTypes.audio,
    icon: 'text_to_audio.svg',
  },
];

export const DashboardCardData: DashboardCardDataType[] = [
  {
    id: 'b-roll',
    header: 'AI Videos',
    subheader:
      'Generate stunning AI video clips by simply describing the scene. Perfect for enhancing your videos with captivating visuals.',
    icon: '/assets/icons/Broll.svg',
    link: '/broll',
  },
  {
    id: 'talking-face',
    header: 'Lip Sync',
    subheader:
      'Upload an image or video of yourself to create a personalized lip sync avatar that brings your words to life.',
    icon: '/assets/icons/TalkingFace.svg',
    link: '/create-video',
  },
  {
    id: 'text-to-image',
    header: 'Image',
    subheader:
      'Create high-quality, AI-generated images tailored to your needs. Just describe what you envision, and we’ll bring it to life.',
    icon: '/assets/icons/AiImage.svg',
    link: '/text-to-image',
  },
  {
    id: 'text-to-audio',
    header: 'Audio-Voiceover',
    subheader:
      'Get professional voiceovers instantly. Provide your script, choose a voice, and let AI handle the rest.',
    icon: '/assets/icons/AudioVoiceover.svg',
    link: '/text-to-audio',
  },
  {
    id: 'audio-cloning',
    header: 'Audio-Cloning',
    subheader:
      'Upload a recording of yourself to create a personalized audio clone. Transform text into lifelike audio using your own unique voice.',
    icon: '/assets/icons/AudioCloning.svg',
    link: '/cloned-audios',
  },
  {
    id: 'captions-effects',
    header: 'Captions & Effects',
    subheader:
      'Upload a video, and our AI will add captions, transitions, and b-roll to make it shine.',
    icon: '/assets/icons/BrollCaption.svg',
    link: '/broll-caption',
  },
  {
    id: 'ai-text',
    header: 'Chatbot',
    subheader:
      'Tell us what type of text you need—scripts, email drafts, or fresh ideas. Our AI generates tailored content to match your vision.',
    icon: '/assets/icons/AiText.svg',
    link: '/ai-text',
  },
  {
    id: 'ai-music',
    header: 'AI Music',
    subheader: 'Create the perfect soundtrack for your mood and style using our AI.',
    icon: '/assets/icons/AiMusic.svg',
    link: '/music',
  },
  {
    id: 'upcoming',
    header: 'Upcoming...',
    subheader: '',
    icon: '/assets/icons/Upcoming.svg',
  },
];

export const DummyBrandKit = [
  {
    userId: 1,
    color: '#000',
    font_size: '12px',
    font_family: 'cursive',
  },
  {
    userId: 2,
    color: '#000',
    font_size: '12px',
    font_family: 'cursive',
  },
  {
    userId: 3,
    color: '#000',
    font_size: '12px',
    font_family: 'cursive',
  },
  {
    userId: 4,
    color: '#000',
    font_size: '12px',
    font_family: 'cursive',
  },
];

// Mocked public API response
export const publicData = [
  {
    id: '1',
    name: 'John Doe',
    thumbnail: '',
  },
  {
    id: '2',
    name: 'Jane Smith',
    thumbnail: '',
  },
  {
    id: '3',
    name: 'Mike Johnson',
    thumbnail: '',
  },
  {
    id: '4',
    name: 'Emily Brown',
    thumbnail: '',
  },
  {
    id: '5',
    name: 'David Wilson',
    thumbnail: '',
  },
  {
    id: '11',
    name: 'John Doe',
    thumbnail: '',
  },
];

export const AUDIO_IMAGE = AudioImage;
export const MICROPHONE_IMAGE = Microphone;
export const LANDSCAPE_BUTTON = LandscapeButton;
export const POTRAIT_BUTTON = PotraitButton;
export const SQUARE_BUTTON = SquareButton;

export enum CreateVideoSideMenuItemEnum {
  AVATAR = 'avatar',
  SCRIPT = 'script',
  PRICING = 'pricing',
  CHANGE_BG = 'change background',
}

export const CREATE_VIDEO_SIDEMENU = {
  top: [
    {
      id: CreateVideoSideMenuItemEnum.AVATAR,
      label: CreateVideoSideMenuItemEnum.AVATAR,
      icon: 'ph:user',
    },
    {
      id: CreateVideoSideMenuItemEnum.SCRIPT,
      label: CreateVideoSideMenuItemEnum.SCRIPT,
      icon: 'ph:scroll',
    },
    {
      id: CreateVideoSideMenuItemEnum.CHANGE_BG,
      label: CreateVideoSideMenuItemEnum.CHANGE_BG,
      icon: 'material-symbols:background-replace-rounded',
    },
  ],
  bottom: [
    {
      id: CreateVideoSideMenuItemEnum.PRICING,
      label: CreateVideoSideMenuItemEnum.PRICING,
      icon: 'fa:diamond',
    },
  ],
};

export const API_CONSTANTS = {
  AUDIO_LIST: {
    key: ['AudioList'],
    path: '/api/audios',
  },
  AUDIO_LIST_PUBLIC: {
    key: ['AudioListPublic'],
    path: '/api/audios/get-public-voices',
  },
  AUDIO_CLONE: {
    key: ['AudioList'],
    path: '/api/audios',
  },
  PRIVATE_AVATAR: {
    key: ['PrivateAvatar'],
    path: '/api/avatars',
  },
  PUBLIC_AVATAR: {
    key: ['PublicAvatar'],
    path: '/api/avatars/get-public-avatars',
  },
  PUBLIC_AUDIO_LIST: {
    key: ['PublicAudio'],
    path: '/api/audios/get-public-voices',
  },
  CREATE_AVATAR: {
    key: ['PrivateAvatar'],
    path: '/api/avatars',
  },
  ALL_VIDEOS: {
    key: ['AllVideos'],
    path: '/api/videos/all',
  },
  CREATE_VIDEOS: {
    key: ['AllVideos'],
    path: '/api/videos/create',
  },
  GENERATE_SCRIPT: {
    key: ['AIScript'],
    path: '/api/script/generate',
  },
  GET_PRESIGNED_URL: {
    key: ['PesignedUrl'],
    path: '/api/s3/get-presigned-url',
  },
  CREATE_PAYMENT: {
    Key: ['CreatePayment'],
    path: '/api/payments/create',
  },
  CREATE_PAYMENT_METHOD: {
    Key: ['CreatePaymentMethod'],
    path: '/api/payments/create-payment-method',
  },
  CREATE_PLAN: {
    Key: ['ActivePlan'],
    path: '/api/payments/create-plan',
  },
  ACTIVE_PLANS: {
    Key: ['ActivePlan'],
    path: '/api/payments/active-plans',
  },
  SHARE_VIDEO: {
    key: ['ShareVideo'],
    path: '/api/videos/share-video',
  },
  VIDEO_SHARED_WITH_ME: {
    key: ['SharedVideo'],
    path: '/api/videos/shared-with-me',
  },
  VIDEO_DETAILS: {
    key: ['VideosDetails'],
    path: '/api/videos/get-video/',
  },
  GET_DRAFT_CONTENT: {
    key: ['DraftContent'],
    path: '/api/videos/draft-videos',
  },
  GET_USER: {
    key: ['GetUser'],
    path: '/api/users/get-user',
  },
  UPDATE_USER: {
    key: ['UpdateUser'],
    path: 'api/users/update-user',
  },
  UPDATE_USER_REFERRAL: {
    key: ['UpdateUserReferral'],
    path: 'api/users/update-user-referral',
  },
  UPDATE_USER_STATUS: {
    key: ['UpdateUserStatus'],
    path: 'api/users/update-user-status',
  },
  REQUIRED_CREDITS: {
    key: ['RequiredCredits'],
    path: 'api/videos/required-credits',
  },
  CANCEL_PAYMENT: {
    Key: ['CancelPayment'],
    path: '',
  },
  DELETE_VIDEO: {
    key: ['AllVideos'],
    path: '/api/videos/delete/',
  },
  USER_CREDITS: {
    key: ['userCredits'],
    path: '/api/videos/user-credits',
  },
  ACTIVE_SUBSCRIPTION: {
    key: ['ActiveSubscription'],
    path: '/api/users/active-subscriptions',
  },
  PAYMENT_STATUS: {
    key: ['PaymentStatus'],
    path: '/api/payments/payment-details',
    keyToInvalidate: ['userCredits', 'ActiveSubscription'],
  },
  SHARE_URL: {
    key: ['ShareURL'],
    path: 'api/videos/share-url',
  },
  UPDATE_VIDEO: {
    key: ['UpdateVideo'],
    path: 'api/videos/update',
  },
  ALL_BROLL_VIDEOS: {
    key: ['allBrollVideos'],
    path: 'api/video/all',
  },
  CLONE_VIDEO: {
    key: ['CloneVideo'],
    path: 'api/video/clone-video',
  },
  SEND_EMAIL: {
    key: ['SendEmail'],
    path: 'api/users/mail-user',
  },
};

export const SUBSCRIPTION_PLAN = [
  {
    name: 'Free',
    fee: '0',
    message: 'No Credit Card Needed',
    description: `A plan with Free features`,
    includes: ['10 credit', 'Access to core platform', 'Single user workspace'],
    highlights: [
      'Avatar Video',
      'Video Translation',
      'AI Trust & Safety',
      'Standard Video Generation',
    ],
    interval: 'Monthly',
    planExpiration: '2024-12-31T23:59:59Z',
    amount: 0,
    currency: 'USD',
    credits: 10,
  },
  {
    name: 'Creator',
    fee: '119',
    message: 'Access more credits and premium features',
    description: `A plan with Creator features`,
    includes: ['150 credits', 'Access to core platform', 'Single user workspace'],
    highlights: [
      'Everything in Free',
      'Instant Avatars',
      'Watermark Removal',
      'Fast Video Generation',
    ],
    interval: 'Monthly',
    planExpiration: '2024-12-31T23:59:59Z',
    amount: 119,
    currency: 'USD',
    credits: 150,
  },
  {
    name: 'Bussiness Plan',
    fee: '220',
    message: 'Access more credits and premium features',
    description: `A plan with bussiness premium features`,
    includes: ['250 credits', 'Access to core platform', 'Single user workspace'],
    highlights: [
      'Everything in Free',
      'Instant Avatars',
      'Watermark Removal',
      'Fast Video Generation',
    ],
    interval: 'Monthly',
    planExpiration: '2024-12-31T23:59:59Z',
    amount: 220,
    currency: 'USD',
    credits: 250,
  },
];

export enum EMPTY_SCRAPE_CONTENT {
  TEXT = 'Unable to generate data for this URL, please try some other URL',
}

export const EMPTY_PAGE_TEXT = {
  video: 'No video to display',
  audio: 'No audio to display',
  avatar: 'No avatar to display',
  default: 'No video to display',
  noData: 'No data found',
  image: 'No image to display',
};

export enum REFETCH_INTERVAL {
  AVATAR = 1000 * 20, // 20 seconds
  CREATED_VIDEO = 1000 * 180, // 180 seconds
  DRAFT_VIDEO = 1000 * 10, // 10 seconds
  TEXT_TO_SPEECH = 1000 * 10, // 10 seconds
  AUDIOS = 1000 * 5, // 5 seconds
  BROLL_CAPTION_VIDEO = 1000 * 30,
  CUSTOM_BROLL = 1000 * 5,
}
export const PAYMENT_EXPIRY_TIME = 600;

export enum SHARED_VIDEO_ENUM {
  TRUE = 'true',
}

export const DATA_SCRAPING_ERROR = 'Cannot scrape data for this website';

export const PUBLIC_PAGES = [
  '/',
  '/pricing',
  '/alpha-pricing',
  '/alpha-express-checkout',
  '/special-agent-plan',
  '/special-lifetime-plan',
  '/auth/callback',
  '/auth/recovery',
  '/auth/settings',
  '/settings',
  '/recovery',
  '/auth/error',
  '/express-checkout',
  '/gohighlevel-orders',
  '/orders',
  '/connect-mcp',
];

export const SHARED_VIDEO_ROUTE = '/public-shared-video';
export const URL_SHORTNER_HOST = 'https://tinyurl.com/';

export const TEXT_TO_SPEECH_MAX_TEXT_LENGTH = 10000;

export const TEXT_TO_SPEECH_MAX_NAME_LENGTH = 25;

export const RECENT_UPLOADS_LIMIT = 1000;

export const VIDEO_DEFAULT_NAME_PREFIX = 'Sample Video ';
export const IMAGE_DEFAULT_NAME_PREFIX = 'Sample Image ';
export const AVATAR_DEFAULT_NAME_PREFIX = 'Sample Avatar ';
export const AUDIO_DEFAULT_NAME_PREFIX = 'Sample Audio ';
export const PROJECT_NAME_PREFIX = 'Untitled Project ';

export const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/x-msvideo', //avi
  'video/avi',
  'video/quicktime',
];

export const AI_SCRIPT_ERR_MSG =
  'The input provided does not seem to be a valid topic or request. Please provide a clear and meaningful input to generate content';

export const AI_SCRIPT_LIMIT_MSG =
  'You have reached maximum AI Text limit of your plan. Kindly upgrade it.';

export const enum ContentType {
  Audio,
  Video,
  Avatar,
  ContentDraft,
}

export const COMMON_INSTRUCTIONS = [
  `Works best with images`,
  `Face should be present in all the frames.`,
  `Your face should not be too close to camera.`,
  `There should be minimal movement of face during recording.`,
  `Ensure you have good lighting that evenly illuminates your face.`,
];
export const INSTRUCTIONS_VIDEO_URL = '';
export const INSTRUCTIONS_PAGE_PATH = 'https://txt2create.com/how-to-upload';

export const EXPIRY_TIME = {
  '7Days': '604800',
};

export enum EditVideoTabsEnum {
  B_ROLL = 'B_ROLL',
  CAPTION = 'CAPTION',
  BOOST = 'BOOST',
}

export const CAPTION_Y_POS_MIN = 0;
export const CAPTION_Y_POS_MAX = 90;
export const CAPTION_FONT_SIZE_MIN = 8;
export const CAPTION_FONT_SIZE_MAX = 200;
export const AI_HOOK_DURATION_MIN = 1;
export const AI_HOOK_DURATION_MAX = 5;
export const DEFAULT_EDIT_VIDEO_THEME_DATA = {
  fontStyle: {
    fontFamily: 'Sora',
    fontWeight: 400,
    fontColor: '#FFFFFF',
    fontSize: 70,
    uppercase: true,
    textShadow: TextShadow.Small,
    stroke: Stroke.None,
    strokeColor: '#000000',
  },
  captionStyle: {
    maxWordsPerLine: 5,
    positionY: 5,
    hasAnimation: true,
    showPunctuation: true,
    autoEmoji: '',
    emojiAnimation: false,
    highlightColor1: '#FF5733',
    highlightColor2: '#C70039',
    highlightColor3: '#900C3F',
    punctuation: true,
    captionStyleId: CaptionStyleId.Horimozi1,
    enableFitText: false,
  },
};

export const STATUS_REGISTRATION_REQUIREMENT: {
  registrationRequired: string[];
  completed: string[];
} = {
  registrationRequired: [
    Status.NotStarted,
    Status.AvatarFaceDetection,
    Status.AvatarVideoConvertionToMp4,
    Status.AvatarCreatingThumbnail,
    Status.AvatarRemovingBackground,
    Status.CompressingVideo,
    Status.ExtractingAudio,
    Status.ExtractingCaption,
    Status.GeneratingBroll,
    Status.ApplyingAIBroll,
    Status.InProgress,
    Status.InQueue,
  ],
  completed: [Status.Success, Status.Error],
};

export const SOUND_EFFECTS = [
  {
    name: 'Pop',
    fileName: 'Pop.mp3',
  },
  {
    name: 'Page Flip',
    fileName: 'PageFlip.mp3',
  },
  {
    name: 'Slice',
    fileName: 'Slice.mp3',
  },
  {
    name: 'Flash',
    fileName: 'Flash.mp3',
  },
  {
    name: 'Whoosh',
    fileName: 'Whoosh.mp3',
  },
  {
    name: 'Camera Flash',
    fileName: 'CameraFlash.mp3',
  },
];

export const LOGIN_ERR_MSG =
  'Your account has been blocked. For support, contact support@txt2create.com.';

export const AI_MEDIA_GENERATE_ERR_MSGS = [
  'Error while generating',
  'Videos longer than 5 minutes cannot be upscaled. Please trim your video and try again.',
  'Video upscaling timed out after 30 minutes. Please try again.',
  'Prompt did not pass content moderation.',
  'Image did not pass content moderation.',
  'Video did not pass content moderation.',
  'No face found.',
  'Retry limit exceeded, please try after sometime...',
  'Inpaint image dimensions do not match the requested width and height.',
  'Your request was blocked by our moderation system.',
  'The content could not be processed because it contained material flagged by a content checker.',
  'The images or videos provided may contain likenesses of real people or other private information that cannot be processed.',
  'The model did not generate the expected output for this prompt. This may occur for several reasons, including unsafe content, a prompt that is incompatible with the selected media type (e.g., prompting an image model to generate audio), references to missing attachments, or other cases where the input cannot be processed as the requested output type. Please review your inputs and try again.',
  'Could not detect face in the image',
  'Output video has sensitive content.',
  'Output audio has sensitive content.',
];

export enum AiWorkBenchOutputEnum {
  IMAGE = 'Image',
  BROLL = 'AI Video (New)',
  TALKING_FACE = 'Lip Sync',
  VOICEOVER = 'Audio-Voiceover',
  MUSIC = 'Audio-Music',
  TEXT = 'AI Text',
}

export enum AiMusicEnum {
  FOCUS = 'Focus',
  CREATIVE = 'Creative',
}

// Whole seconds accepted by the music generation backend (fal.ai Stable Audio)
export const MUSIC_DURATION_LIMITS = { MIN: 1, MAX: 20 } as const; // seconds

export enum ResolutionEnum {
  '720P' = '720p',
  '480P' = '480p',
  '360P' = '360p',
  '240P' = '240p',
}

export enum OrientationEnum {
  LANDSCAPE = 'Landscape',
  SQUARE = 'Square',
  POTRAIT = 'Potrait',
}

export enum NumGenerationsEnum {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
}

export enum AiVideoModelEnum {
  // AIVIDEOAPI = 'Txt2Create Lite 0',
  SEEDANCE2_5 = 'Seedance 2.5',
  SEEDANCE2_0 = 'Seedance 2.0',
  SEEDANCE2_0_FAST = 'Seedance 2.0 Fast',
  VEO3_1 = 'Google Veo 3.1',
  KLING_V3_PRO = 'Kling 3 Pro',
  KLING_V3_MOTION_CONTROL = 'Kling 3 Motion Control',
  KLING_V2_6_PRO = 'Kling 2.6 Pro',
  VEO3_1_FAST = 'Google Veo 3.1 Fast',
  PIXVERSE_V5 = 'Pixverse V5',
  SEEDANCE_1_PRO = 'Seedance 1.0 Pro',
  VEO3 = 'Google Veo 3',
  VEO3_FAST = 'Google Veo 3 Fast',
  KLING_V2_5_TURBO = 'Kling 2.5 Turbo',
  RUNWAY_ACT_TWO = 'Runway Character Mimic',
  WAN_2_5_PREVIEW = 'Wan-2.5 Preview',
  WAN_2_2_PLUS = 'Wan-2.2 Plus',
  MINIMAX_HAILUO_2 = 'Minimax Hailuo 2',
  WAN_2_1_PLUS = 'Wan-2.1 Plus',
  WAN_2_1_TURBO = 'Wan-2.1 Turbo',
  // ALIBABA = 'Wan-2.1',
  MINIMAX = 'Minimax Video 01',
  MINIMAX2 = 'Minimax Video 01 live2d',
}

export enum AiImageModelType {
  NANOBANANA_2 = 'Nano Banana 2',
  IMAGEGEN2 = 'GPT-Image 2',
  NANOBANANA_PRO = 'Nano Banana Pro',
  USO = 'USO',
  SEEDREAM4_5 = 'Seedream 4.5',
  // SEEDREAM_4 = 'Seedream 4.0',
  FLUXPROV1_1_ULTRA = 'Flux Pro V1.1 Ultra',
  NANOBANANA = 'Nano Banana',
  QWEN = 'Qwen',
  STABILITYAILARGE = 'Stability AI Large',
  RUNWAYGEN4_TURBO = 'Runway Gen 4 Turbo',
  FLUX_SRPO = 'Flux Srpo',
  FLUXPROV1_1 = 'Flux Pro V1.1',
  FLUX_KONTEXT_MAX = 'Flux Kontext Max',
  STABILITYAI = 'Stability AI Turbo',
  STABILITYAIMEDIUM = 'Stability AI Medium',
  RECRAFTAI = 'Recraft V3',
  SEEDREAM_3 = 'Seedream 3.0',
  FLUXREALISM = 'Flux Realism',
  FLUXDEV = 'Flux Dev',
  FLUX_KONTEXT_PRO = 'Flux Kontext Pro',
  FLUXSCHNELL = 'Flux Schnell',
}

export enum AudioModelType {
  ELEVENLABS = 'ElevenLabs',
  DIA = 'dia',
  FISHAUDIO = 'Fish Audio',
}

export const DbModelToDisplayName: Record<string, AudioModelType> = {
  voiceover: AudioModelType.ELEVENLABS,
  fishAudio: AudioModelType.FISHAUDIO,
  dia: AudioModelType.DIA,
};

export enum TalkingFaceModelType {
  REMOTION = 'Talking Face',
  HEDRA = 'Hedra',
  HEYGEN = 'HeyGen',
}

export enum BrollCaptionsAndRenderType {
  REMOTION = 'Remotion',
  CLIPDECK = 'Clipdeck',
}

export enum DurationEnum {
  '5S' = '5',
  '10S' = '10',
}

export const modelDetails: Record<AiVideoModelEnum, AiVideoModelDetails> = {
  // [AiVideoModelEnum.AIVIDEOAPI]: {
  //   durationPerModel: [5, 10],
  //   orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
  //   resolutionPerModel: ['720p', '480p', '360p','240p'],
  //   showUpload: true,
  //   showTailUpload: false,
  //   maxCharLimit: 3500,
  // },
  [AiVideoModelEnum.VEO3]: {
    durationPerModel: [4, 6, 8],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16']],
    resolutionPerModel: ['1080p', '720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 3500,
    maxImageSize: 10,
    showAudio: true,
  },
  [AiVideoModelEnum.VEO3_FAST]: {
    durationPerModel: [4, 6, 8],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16']],
    resolutionPerModel: ['1080p', '720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 3500,
    maxImageSize: 10,
    showAudio: true,
  },
  [AiVideoModelEnum.VEO3_1]: {
    durationPerModel: [4, 6, 8],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16']],
    resolutionPerModel: ['1080p', '720p'],
    showUpload: true,
    showTailUpload: true,
    maxCharLimit: 3500,
    maxImageSize: 10,
    showAudio: true,
    showEnhancePrompt: true,
  },
  [AiVideoModelEnum.VEO3_1_FAST]: {
    durationPerModel: [4, 6, 8],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16']],
    resolutionPerModel: ['1080p', '720p'],
    showUpload: true,
    showTailUpload: true,
    maxCharLimit: 3500,
    maxImageSize: 10,
    showAudio: true,
    showEnhancePrompt: true,
  },
  [AiVideoModelEnum.KLING_V3_MOTION_CONTROL]: {
    durationPerModel: [0],
    orientationPerModel: [],
    resolutionPerModel: [],
    showUpload: false,
    showVideo: true,
    showTailUpload: true,
    showBodyControl: false,
    showCharacter: false,
    maxCharLimit: 2500,
    maxImageSize: 10,
    isStartImageRequired: true,
  },
  [AiVideoModelEnum.RUNWAY_ACT_TWO]: {
    durationPerModel: [0],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
    resolutionPerModel: ['720p', '480p', '360p', '240p'],
    showUpload: false,
    showTailUpload: false,
    showBodyControl: true,
    showCharacter: true,
    maxCharLimit: 0,
    maxImageSize: 15,
    isStartImageRequired: true,
  },
  // [AiVideoModelEnum.ALIBABA]: {
  //   durationPerModel: [5],
  //   orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16']],
  //   resolutionPerModel: ['720p', '480p', '360p','240p'],
  //   showUpload: false,
  //   showTailUpload: false,
  //   maxCharLimit: 3500,
  // },
  [AiVideoModelEnum.WAN_2_5_PREVIEW]: {
    durationPerModel: [5],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
    resolutionPerModel: ['1080p', '720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 800,
  },
  [AiVideoModelEnum.WAN_2_2_PLUS]: {
    durationPerModel: [5],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: ['1080p', '720p', '480p', '360p', '240p'],
    showUpload: false,
    showTailUpload: false,
    maxCharLimit: 3500,
  },
  [AiVideoModelEnum.WAN_2_1_TURBO]: {
    durationPerModel: [5],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: ['720p', '480p', '360p', '240p'],
    showUpload: false,
    showTailUpload: false,
    maxCharLimit: 3500,
  },
  [AiVideoModelEnum.WAN_2_1_PLUS]: {
    durationPerModel: [5],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: ['720p', '480p', '360p', '240p'],
    showUpload: false,
    showTailUpload: false,
    maxCharLimit: 3500,
  },
  [AiVideoModelEnum.KLING_V2_5_TURBO]: {
    durationPerModel: [5, 10],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
    resolutionPerModel: ['1080p', '720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 2500,
    maxImageSize: 10,
  },
  [AiVideoModelEnum.KLING_V2_6_PRO]: {
    durationPerModel: [5, 10],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
    resolutionPerModel: ['1080p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 2500,
    maxImageSize: 10,
    showAudio: true,
  },
  [AiVideoModelEnum.KLING_V3_PRO]: {
    durationPerModel: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
    resolutionPerModel: [],
    showUpload: true,
    showTailUpload: true,
    maxCharLimit: 2500,
    maxImageSize: 10,
    showAudio: true,
    mutliShot: ['Customize', 'Intelligent'],
  },
  [AiVideoModelEnum.MINIMAX]: {
    durationPerModel: [5],
    orientationPerModel: [AspectRatios['16_9']],
    resolutionPerModel: ['720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 2000,
    maxImageSize: 10,
  },
  [AiVideoModelEnum.MINIMAX2]: {
    durationPerModel: [5],
    orientationPerModel: [AspectRatios['16_9']],
    resolutionPerModel: ['720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 2000,
    maxImageSize: 10,
  },
  [AiVideoModelEnum.MINIMAX_HAILUO_2]: {
    durationPerModel: [6],
    orientationPerModel: [AspectRatios['16_9']],
    resolutionPerModel: ['1080p', '720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 2000,
    maxImageSize: 10,
  },
  [AiVideoModelEnum.PIXVERSE_V5]: {
    durationPerModel: [5],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: ['1080p', '720p', '480p', '360p', '240p'],
    showUpload: true,
    showTailUpload: true,
    maxCharLimit: 2000,
    maxImageSize: 10,
  },
  [AiVideoModelEnum.SEEDANCE_1_PRO]: {
    durationPerModel: [5, 10],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
    ],
    resolutionPerModel: ['1080p', '720p', '480p'],
    showUpload: true,
    showTailUpload: false,
    maxCharLimit: 2000,
    maxImageSize: 10,
  },
  [AiVideoModelEnum.SEEDANCE2_0]: {
    durationPerModel: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
    ],
    resolutionPerModel: ['1080p', '720p', '480p'],
    showUpload: true,
    showTailUpload: true,
    maxCharLimit: 2000,
    maxImageSize: 30,
    showAudio: true,
  },
  [AiVideoModelEnum.SEEDANCE2_0_FAST]: {
    durationPerModel: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
    ],
    resolutionPerModel: ['720p', '480p'],
    showUpload: true,
    showTailUpload: true,
    maxCharLimit: 2000,
    maxImageSize: 30,
    showAudio: true,
  },
  [AiVideoModelEnum.SEEDANCE2_5]: {
    durationPerModel: [
      4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,
      29, 30,
    ],
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
    ],
    resolutionPerModel: ['720p', '480p'],
    showUpload: true,
    showTailUpload: true,
    maxCharLimit: 2000,
    maxImageSize: 30,
    showAudio: true,
  },
};

export const imageModelDetails: Record<AiImageModelType, AiImageModelDetails> = {
  [AiImageModelType.STABILITYAI]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
      AspectRatios['9_21'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    stylesPerModel: [
      { label: '3D Model', value: '3d-model' },
      { label: 'Analog Film', value: 'analog-film' },
      { label: 'Anime', value: 'anime' },
      { label: 'Cinematic', value: 'cinematic' },
      { label: 'Comic Book', value: 'comic-book' },
      { label: 'Digital Art', value: 'digital-art' },
      { label: 'Enhance', value: 'enhance' },
      { label: 'Fantasy Art', value: 'fantasy-art' },
      { label: 'Isometric', value: 'isometric' },
      { label: 'Line Art', value: 'line-art' },
      { label: 'Low Poly', value: 'low-poly' },
      { label: 'Modeling Compound', value: 'modeling-compound' },
      { label: 'Neon Punk', value: 'neon-punk' },
      { label: 'Origami', value: 'origami' },
      { label: 'Photographic', value: 'photographic' },
      { label: 'Pixel Art', value: 'pixel-art' },
      { label: 'Tile Texture', value: 'tile-texture' },
    ],
    maxCharLimit: 3500,
    maxImageSize: 10,
  },
  [AiImageModelType.STABILITYAILARGE]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
      AspectRatios['9_21'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    stylesPerModel: [
      { label: '3D Model', value: '3d-model' },
      { label: 'Analog Film', value: 'analog-film' },
      { label: 'Anime', value: 'anime' },
      { label: 'Cinematic', value: 'cinematic' },
      { label: 'Comic Book', value: 'comic-book' },
      { label: 'Digital Art', value: 'digital-art' },
      { label: 'Enhance', value: 'enhance' },
      { label: 'Fantasy Art', value: 'fantasy-art' },
      { label: 'Isometric', value: 'isometric' },
      { label: 'Line Art', value: 'line-art' },
      { label: 'Low Poly', value: 'low-poly' },
      { label: 'Modeling Compound', value: 'modeling-compound' },
      { label: 'Neon Punk', value: 'neon-punk' },
      { label: 'Origami', value: 'origami' },
      { label: 'Photographic', value: 'photographic' },
      { label: 'Pixel Art', value: 'pixel-art' },
      { label: 'Tile Texture', value: 'tile-texture' },
    ],
    maxCharLimit: 3500,
    maxImageSize: 10,
  },
  [AiImageModelType.STABILITYAIMEDIUM]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
      AspectRatios['9_21'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    stylesPerModel: [
      { label: '3D Model', value: '3d-model' },
      { label: 'Analog Film', value: 'analog-film' },
      { label: 'Anime', value: 'anime' },
      { label: 'Cinematic', value: 'cinematic' },
      { label: 'Comic Book', value: 'comic-book' },
      { label: 'Digital Art', value: 'digital-art' },
      { label: 'Enhance', value: 'enhance' },
      { label: 'Fantasy Art', value: 'fantasy-art' },
      { label: 'Isometric', value: 'isometric' },
      { label: 'Line Art', value: 'line-art' },
      { label: 'Low Poly', value: 'low-poly' },
      { label: 'Modeling Compound', value: 'modeling-compound' },
      { label: 'Neon Punk', value: 'neon-punk' },
      { label: 'Origami', value: 'origami' },
      { label: 'Photographic', value: 'photographic' },
      { label: 'Pixel Art', value: 'pixel-art' },
      { label: 'Tile Texture', value: 'tile-texture' },
    ],
    maxCharLimit: 3500,
    maxImageSize: 10,
  },
  [AiImageModelType.IMAGEGEN2]: {
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
    resolutionPerModel: ['1k', '2k', '4k'],
    showUpload: true,
    stylesPerModel: [],
    maxCharLimit: 3500,
    showSecondUpload: true,
    maxImageSize: 50,
  },
  [AiImageModelType.NANOBANANA]: {
    orientationPerModel: [AspectRatios['1_1']],
    resolutionPerModel: [],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 3500,
    maxImageSize: 50,
  },
  [AiImageModelType.NANOBANANA_PRO]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['21_9'],
      AspectRatios['4_3'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
      AspectRatios['5_4'],
      AspectRatios['4_5'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: ['1K', '2K', '4K'],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 3500,
    maxImageSize: 50,
    numGenerations: 1,
  },
  [AiImageModelType.NANOBANANA_2]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['21_9'],
      AspectRatios['4_3'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
      AspectRatios['5_4'],
      AspectRatios['4_5'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: ['0.5K', '1K', '2K', '4K'],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 3500,
    maxImageSize: 30,
    numGenerations: 1,
  },
  [AiImageModelType.RUNWAYGEN4_TURBO]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 1000,
    maxImageSize: 5,
  },
  [AiImageModelType.RECRAFTAI]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: [],
    showUpload: false,
    stylesPerModel: [
      { label: 'Realistic Image', value: 'realistic_image' },
      { label: 'Digital Illustration', value: 'digital_illustration' },
      { label: 'Vector Illustration', value: 'vector_illustration' },
      { label: 'Realistic Image / B&W', value: 'realistic_image/b_and_w' },
      { label: 'Realistic Image / Hard Flash', value: 'realistic_image/hard_flash' },
      { label: 'Realistic Image / HDR', value: 'realistic_image/hdr' },
      { label: 'Realistic Image / Natural Light', value: 'realistic_image/natural_light' },
      { label: 'Realistic Image / Studio Portrait', value: 'realistic_image/studio_portrait' },
      { label: 'Realistic Image / Enterprise', value: 'realistic_image/enterprise' },
      { label: 'Realistic Image / Motion Blur', value: 'realistic_image/motion_blur' },
      { label: 'Digital Illustration / Pixel Art', value: 'digital_illustration/pixel_art' },
      { label: 'Digital Illustration / Hand Drawn', value: 'digital_illustration/hand_drawn' },
      { label: 'Digital Illustration / Grain', value: 'digital_illustration/grain' },
      {
        label: 'Digital Illustration / Infantile Sketch',
        value: 'digital_illustration/infantile_sketch',
      },
      {
        label: 'Digital Illustration / 2D Art Poster',
        value: 'digital_illustration/2d_art_poster',
      },
      { label: 'Digital Illustration / Handmade 3D', value: 'digital_illustration/handmade_3d' },
      {
        label: 'Digital Illustration / Hand Drawn Outline',
        value: 'digital_illustration/hand_drawn_outline',
      },
      {
        label: 'Digital Illustration / Engraving Color',
        value: 'digital_illustration/engraving_color',
      },
      {
        label: 'Digital Illustration / 2D Art Poster 2',
        value: 'digital_illustration/2d_art_poster_2',
      },
      { label: 'Vector Illustration / Engraving', value: 'vector_illustration/engraving' },
      { label: 'Vector Illustration / Line Art', value: 'vector_illustration/line_art' },
      { label: 'Vector Illustration / Line Circuit', value: 'vector_illustration/line_circuit' },
      { label: 'Vector Illustration / Linocut', value: 'vector_illustration/linocut' },
    ],
    maxCharLimit: 4000,
  },
  [AiImageModelType.FLUXPROV1_1]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: [],
    showUpload: false,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.FLUXPROV1_1_ULTRA]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
      AspectRatios['9_21'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
    ],
    resolutionPerModel: [],
    showUpload: false,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.FLUXREALISM]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: [],
    showUpload: false,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.FLUXDEV]: {
    orientationPerModel: [AspectRatios['16_9'], AspectRatios['9_16'], AspectRatios['1_1']],
    resolutionPerModel: [],
    showUpload: true,
    stylesPerModel: [],
    maxCharLimit: 4000,
    maxImageSize: 10,
  },
  [AiImageModelType.FLUXSCHNELL]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: [],
    showUpload: false,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.FLUX_KONTEXT_MAX]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
      AspectRatios['9_21'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.FLUX_KONTEXT_PRO]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['21_9'],
      AspectRatios['9_21'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.FLUX_SRPO]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    showSecondUpload: false,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.SEEDREAM_3]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
      AspectRatios['3_2'],
      AspectRatios['2_3'],
    ],
    resolutionPerModel: ['1440p', '1080p', '720p'],
    showUpload: false,
    stylesPerModel: [],
    maxCharLimit: 4000,
  },
  [AiImageModelType.SEEDREAM4_5]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: ['4096p', '2160p', '1440p', '1080p', '720p'],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 4000,
    maxImageSize: 10,
  },
  // [AiImageModelType.SEEDREAM_4]: {
  //   orientationPerModel: [
  //     AspectRatios['16_9'],
  //     AspectRatios['9_16'],
  //     AspectRatios['1_1'],
  //     AspectRatios['4_3'],
  //     AspectRatios['3_4'],
  //   ],
  //   resolutionPerModel: ['4096p', '2160p', '1440p', '1080p', '720p'],
  //   showUpload: true,
  //   showSecondUpload: true,
  //   stylesPerModel: [],
  //   maxCharLimit: 4000,
  // },
  [AiImageModelType.USO]: {
    orientationPerModel: [
      AspectRatios['16_9'],
      AspectRatios['9_16'],
      AspectRatios['1_1'],
      AspectRatios['4_3'],
      AspectRatios['3_4'],
    ],
    resolutionPerModel: [],
    showUpload: true,
    showSecondUpload: true,
    stylesPerModel: [],
    maxCharLimit: 4000,
    isStartImageRequired: true,
  },
  [AiImageModelType.QWEN]: {
    orientationPerModel: [AspectRatios['4_3']],
    resolutionPerModel: [],
    showUpload: true,
    showSecondUpload: false,
    stylesPerModel: [],
    maxCharLimit: 800,
  },
};

type AiWorkbenchOutputDetails = {
  [key in AiWorkBenchOutputEnum]: {
    message: string;
    illustration: string;
    style?: CSSProperties;
  };
};

export const AI_WORKBENCH_OUTPUT_DETAILS: AiWorkbenchOutputDetails = {
  [AiWorkBenchOutputEnum.BROLL]: {
    message:
      'Generate stunning b-roll clips by simply describing the scene. Perfect for enhancing your videos with captivating visuals.',
    illustration: '/assets/illustration/ai-broll.svg',
    style: {
      right: -30,
      bottom: -1,
      height: '35%',
      width: '66%',
    },
  },
  [AiWorkBenchOutputEnum.TALKING_FACE]: {
    message:
      'Choose avatar of yourself to create a personalized Lip Sync avatar that brings your words to life.',
    illustration: '/assets/illustration/talking-face.svg',
    style: {
      right: -20,
      bottom: 0,
      height: '45%',
      width: '65%',
    },
  },
  [AiWorkBenchOutputEnum.IMAGE]: {
    message:
      'Create high-quality, AI-generated images tailored to your needs. Just describe what you envision, and we’ll bring it to life.',
    illustration: '/assets/illustration/ai-image.svg',
    style: {
      right: -22,
      bottom: 8,
      height: '45%',
      width: '65%',
    },
  },
  [AiWorkBenchOutputEnum.VOICEOVER]: {
    message:
      'Get professional voiceovers instantly. Provide your script, choose a voice, and let AI handle the rest.',
    illustration: '/assets/illustration/audio-voiceover.svg',
    style: {
      right: -30,
      bottom: 0,
      height: '45%',
      width: '60%',
    },
  },
  [AiWorkBenchOutputEnum.MUSIC]: {
    message: 'Generate captivating music tracks for your videos.',
    illustration: '/assets/illustration/ai-music.svg',
    style: {
      right: 0,
      bottom: 8,
      height: '45%',
      width: '65%',
    },
  },
  [AiWorkBenchOutputEnum.TEXT]: {
    message: 'Generate scripts, brainstorm ideas, and explore endless possibilities.',
    illustration: '/assets/illustration/ai-text.svg',
    style: {
      right: -58,
      bottom: 8,
      height: '40%',
      width: '80%',
    },
  },
};

export const PAGE_DATA_LIMIT = 20;

export const PEXELS_URL = 'https://www.pexels.com/';
export const PIXABAY_URL = 'https://pixabay.com/';

export const LOCATION_DATA_URL = 'https://public-static-dev.txt2create.com/assets/location_data';
